import { StatisticsKind, StatisticsSource } from '..';
import { createZoneStylesWithAlphaInterpolation, type VectorMapLayer } from '@common';

export const needSourceLayerSelector = (kind: StatisticsKind): boolean => {
  return [
    StatisticsKind.YIELD_APPLIED_DOSE,
    StatisticsKind.YIELD_SOIL_PARAMETER,
    StatisticsKind.YIELD_STEM_NUMBER,
    StatisticsKind.YIELD_ZONE_STRENGTH
  ].includes(kind);
};

export const statisticsKindSecondarySourceMap: Partial<Record<StatisticsKind, StatisticsSource>> = {
  [StatisticsKind.SOIL_TEMPERATURE]: StatisticsSource.SOIL_TEMPERATURE,
  [StatisticsKind.YIELD_APPLIED_DOSE]: StatisticsSource.APPLIED_DOSE,
  [StatisticsKind.YIELD_SOIL_PARAMETER]: StatisticsSource.SOIL_SAMPLE,
  [StatisticsKind.YIELD_STEM_NUMBER]: StatisticsSource.STEM_NUMBER,
  [StatisticsKind.YIELD_ZONE_STRENGTH]: StatisticsSource.ZONE_STRENGTH
};

export const statisticsKindFieldNameMap: Partial<Record<StatisticsKind, string>> = {
  [StatisticsKind.YIELD_APPLIED_DOSE]: 'appliedDose',
  [StatisticsKind.YIELD_SOIL_PARAMETER]: 'soilSample',
  [StatisticsKind.YIELD_STEM_NUMBER]: 'stemNumber',
  [StatisticsKind.YIELD_ZONE_STRENGTH]: 'zoneStrength'
};

const calculateZoneStrengthDeltaBreaks = (values: number[]) => {
  const min = Math.min(...values, -1);
  const max = Math.max(...values, 1);
  return { min, max, breaks: [min, 0, max] };
};

export const generateColorInfoForZoneStrengthDelta = async (values: number[], colorMap: any) => {
  const { min, max, breaks } = calculateZoneStrengthDeltaBreaks(values);
  const colors = colorMap.colors;

  const colorBreaks: { color: string; value: number; percent: number }[] = [];
  for (let i = 0; i < breaks.length; i++) {
    colorBreaks.push({
      color: colors[i],
      value: breaks[i],
      percent: ((breaks[i] - min) / (max - min)) * 100
    });
  }

  return {
    min,
    max,
    breaks,
    colorBreaks
  };
};

export const zoneStrengthDeltaStyleFn = async (layer: VectorMapLayer, values: number[]) => {
  const { breaks } = calculateZoneStrengthDeltaBreaks(values);

  return createZoneStylesWithAlphaInterpolation(layer, breaks);
};

export const getChoosableYears = (personalDataYear?: number) => {
  const firstYear = 2023;
  const lastYear = personalDataYear ?? firstYear;

  return Array.from({ length: lastYear - firstYear + 1 }, (_, i) => firstYear + i);
};

export const fieldHasMultipleValues = (source: StatisticsSource): boolean => {
  return [StatisticsSource.APPLIED_DOSE, StatisticsSource.STEM_NUMBER].includes(source);
};
